import {Skeleton} from '@mui/material';
import {ErrorState} from 'presentation/components';
import {translations} from 'presentation/translations-new';
import React, {useMemo} from 'react';
import {useAccountInformation} from 'presentation/pages/private/hooks';
import {LayoutContainer} from '../../components/LayoutContainer';
import {PatientDataCard} from './components/PatientDataCard';
import {usePatientData} from './hooks/usePatientData';

const {error} = translations['pt-br'].privateFlow.myHospitalization.patientData;

export const MyHospitalizationPatientData = () => {
	const {data, isError, isLoading, refetch} = usePatientData();
	const {
		beneficiary: {cdUsuarioC, nmPlano},
	} = useAccountInformation();

	const patientProps = useMemo(() => {
		if (data) {
			return {...data, wallet: cdUsuarioC, plan: nmPlano};
		}
		return undefined;
	}, [data, cdUsuarioC, nmPlano]);

	if (isLoading) {
		return (
			<LayoutContainer>
				<Skeleton variant="rectangular" height={475} />
			</LayoutContainer>
		);
	}

	if (isError || !data || !patientProps) {
		return (
			<LayoutContainer>
				<ErrorState
					title={error.title}
					description={error.description}
					handleRefresh={refetch}
				/>
			</LayoutContainer>
		);
	}

	return (
		<LayoutContainer>
			<PatientDataCard patient={patientProps} />
		</LayoutContainer>
	);
};
